<template>
  <div class="menu-container">
    <MenuIcon class="hamburger" v-model="isActive" @input="showMenu" />
    <nav class="menu-overlay" :class="{ 'is-visible': isActive }">
      <ul ref="list" @click="showMenu(false)">
        <li><router-link :to="{ path: '#home', query: { scroll: true } }">Home</router-link></li>
        <li><router-link :to="{ path: '#about', query: { scroll: true } }">About us</router-link></li>
        <li><router-link :to="{ path: '#career', query: { scroll: true } }">Careers</router-link></li>
        <li><router-link :to="{ path: '#contact', query: { scroll: true } }">Contact</router-link></li>
      </ul>
    </nav>
  </div>
</template>

<script>
import MenuIcon from './MenuIcon';

export default {
  name: 'Menu',

  components: { MenuIcon },

  data() {
    return {
      isMobile: null,
      isActive: false,
      transitionDelay: 0,
      transitionTiming: 100,
    };
  },

  methods: {
    showMenu(show) {
      this.isActive = show;
      if (!this.isMobile) return;

      if (show) {
        document.body.classList.add('no-scroll');
        this.showItems();
      } else {
        document.body.classList.remove('no-scroll');
        this.hideItems();
      }
    },
    showItems() {
      setTimeout(() => {
        Array.from(this.$refs.list.getElementsByTagName('li')).forEach((el, i) => {
          setTimeout(() => {
            el.classList.add('show');
          }, (i + 1) * this.transitionTiming);
        });
      }, this.transitionDelay);
    },
    hideItems() {
      Array.from(this.$refs.list.getElementsByTagName('li')).forEach((el, i) => {
        el.classList.remove('show');
      });
    },
  },

  mounted() {
    this.isMobile = getComputedStyle(this.$el.querySelector('.hamburger'), null).display !== 'none';

    if (!this.isMobile) this.showItems();
  },
};
</script>

<style lang="scss" scoped>
.menu-overlay {
  color: $--color--font-i;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: $--color--fill-3;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s;

  &.is-visible {
    opacity: 1;
    visibility: visible;
  }

  @include respond-to('small') {
    position: static;
    background: transparent;
    opacity: 1;
    visibility: visible;
  }
}

.hamburger {
  position: relative;
  z-index: 1001;

  @include respond-to('small') {
    display: none;
  }
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  @include center;

  li {
    opacity: 0;
    transform: translate(100px, 0);
    transition: opacity 0.3s, transform 0.4s;
  }

  li.show {
    transform: translateX(0);
    opacity: 1;
  }

  li a {
    display: block;
    color: #fff;
    font-family: $--font--secondary;
    font-weight: 600;
    text-decoration: none;
    display: inline-block;
    background-size: 0% 6px;
    background-position: bottom left;
    background-repeat: no-repeat;
    transition: background-size 0.5s cubic-bezier(0.23, 1, 0.32, 1);
    outline: 0;
    @include font-size(46px);
  }

  li a:hover,
  li a.router-link-active {
    background-image: linear-gradient(to right, $--color--primary, $--color--primary);
    background-size: 100% 6px;
  }

  li + li {
    margin-top: 40px;
  }

  @include respond-to('small') {
    position: relative;
    top: auto;
    left: auto;
    transform: translate(0, 0);

    li {
      display: inline-block;
      transform: translate(0, -100px);
    }

    li + li {
      margin-top: 0;
      margin-left: 40px;
    }

    li a {
      text-transform: uppercase;
      font-weight: 500;
      background-size: 0% 2px;
      padding: 6px 0;
      @include font-size(13px);
    }

    li a:hover,
    li a.router-link-active {
      background-size: 100% 2px;
    }
  }
}
</style>
